type CreatorSearch = {
  version?: string;
};

export function creatorSearch(search: Record<string, unknown>): CreatorSearch {
  return typeof search.version === "string" ? { version: search.version } : {};
}
